export const formatNhsId = (nhsId) => {
  if (!nhsId || nhsId.length !== 10) return nhsId;
  return `${nhsId.slice(0, 3)} ${nhsId.slice(3, 6)} ${nhsId.slice(6)}`;
};

export const formatDateOfBirth = (dateOfBirth) => {
  if (!dateOfBirth) return null;
  try {
    const [day, month, year] = dateOfBirth.split('/').map(Number);
    const birthDate = new Date(year, month - 1, day);
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'];
    return `${monthNames[birthDate.getMonth()]} ${birthDate.getDate()}, ${birthDate.getFullYear()}`;
  } catch {
    return dateOfBirth;
  }
};

export const calculateAge = (dateOfBirth) => {
  if (!dateOfBirth) return null;
  try {
    const [day, month, year] = dateOfBirth.split('/').map(Number);
    const birthDate = new Date(year, month - 1, day);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age >= 0 ? `${age}y` : null;
  } catch {
    return null;
  }
};

export const formatTimestamp = (timestamp) => {
  if (!timestamp) return '—';
  try {
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  } catch {
    return '—';
  }
};
